<template>
  <van-popup v-model="showpPopup" :overlay-style="{ background: 'rgba(0,0,0,.7)' }">
    <div class="content-container">
      <div class="money-box">
        <div class="tip-box">
          <span>恭喜你！获得奖励红包!</span>
          <span>赶紧提现奖励吧!</span>
        </div>
        <div class="money">
          <span class="text">{{ showAmount || '0' }}</span
          >元
        </div>
      </div>
      <img class="btn" @click="withdrawalClick" src="@/static/images/activityCenter/202405/01/06.png" />
      <img class="close" @click="showpPopup = false" src="@/static/images/activityCenter/202405/01/close.png" />
    </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      showpPopup: false,
      userType: '',
      workingState: '',
      isSus: '',
      showAmount: '',
      withdrawAmount: ''
    };
  },

  methods: {
    open(showAmount, withdrawAmount, userType, workingState, isSus) {
      this.showpPopup = true;
      this.showAmount = showAmount;
      this.withdrawAmount = withdrawAmount;
      (this.userType = userType),
        (this.workingState = workingState), //1 在职 0 离职
        (this.isSus = isSus); //是否停职
    },

    withdrawalClick() {
      if (this.workingState == 0 || this.isSus == 1 || this.userType != 2) {
        this.$notice.msg('提现失败，在职用户方可提现~');
        return;
      }
      this.showpPopup = false;
      this.$emit('show-withdrawal-form');
    }
  }
};
</script>

<style lang="scss" scoped>
.van-popup {
  background: transparent !important;
  padding-bottom: 390px;
}

.content-container {
  position: relative;
  width: 750px;
  height: 749px;
  background: url('~@/static/images/activityCenter/202405/01/10.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  .money-box {
    margin-top: 135px;
    justify-content: center;
    .tip-box {
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      font-size: 32px;
      color: #772d00;
      font-weight: bold;
    }
    .money {
      color: #fc2e15;
      font-size: 32px;
      text-align: center;
      font-weight: bold;
      margin-top: 10px;
      .text {
        font-size: 90px;
        margin-right: 8px;
      }
    }
  }
  .btn {
    position: absolute;
    width: 377px;
    height: 100px;
    bottom: 95px;
    left: 50%;
    margin-left: -188.5px;
  }
  .close {
    position: absolute;
    width: 60px;
    height: 60px;
    bottom: -100px;
    left: 50%;
    margin-left: -30px;
  }
}
</style>
